import React from "react";
import { ToastContainer } from "react-toastify";
import { AddArticle } from "../components/NewsManagement/Articles/AddArticle";

export const ArticlesAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddArticle />
        </div>
      </div>
    </div>
  );
};
